module.exports = __webpack_public_path__ + "static/media/thumbnail-los-andes.be7e7810.jpg";